import React, { useState } from "react";
import { PageBanner } from "../components/common";
import { ProjectCard } from "../sections/Projects";
import { projects } from "../mock";
import ContactSection from "../sections/ContactSection";

const categories = ["All", "New Build", "Renovation", "Commercial"];

const ProjectsPage = () => {
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <main>
      <PageBanner
        title="Our Projects"
        crumb="Projects"
        image="https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="py-24 bg-white">
        <div className="max-w-[1320px] mx-auto px-5">
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`font-display font-semibold uppercase tracking-wide text-sm px-6 py-3 rounded-sm transition-colors ${
                  filter === c ? "bg-[#CD0008] text-white" : "bg-[#F1F3F7] text-[#0B102D] hover:bg-[#0B102D] hover:text-white"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {shown.map((p) => (
              <ProjectCard key={p.id} p={p} />
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
};

export default ProjectsPage;
